

export const DATA_TABLE_ROW_NUMBER = {
  FIRST: 0,
  SECOND: 1
};

export const DATA_TABLE_HEADER_ROW_ID = 'headerRowId';